export default "__VITE_PUBLIC_ASSET__942f5be7__"